import isNil from 'lodash/isNil';
import {
  PdfTemplateField,
} from 'views/EMR/Settings/PdfTemplateBuilder/types';

const FIELD_SCOPE_PREFIX = 'field:';
const RADIO_GROUP_SCOPE_PREFIX = 'radio-group:';
const CHECKBOX_GROUP_SCOPE_PREFIX = 'checkbox-group:';

export function getFieldHistoryScopeId(field: PdfTemplateField) {
  if (field.type === 'radioGroup') {
    return `${RADIO_GROUP_SCOPE_PREFIX}${field.groupId ?? field.id}`;
  }

  if (field.type === 'checkboxGroup') {
    return `${CHECKBOX_GROUP_SCOPE_PREFIX}${field.groupId ?? field.id}`;
  }

  return `${FIELD_SCOPE_PREFIX}${field.id}`;
}

export function getFieldHistoryScopeByScopeId(
  scopeId: string,
  fields: PdfTemplateField[],
) {
  if (scopeId.startsWith(RADIO_GROUP_SCOPE_PREFIX)) {
    const groupId = scopeId.slice(RADIO_GROUP_SCOPE_PREFIX.length);

    return fields.filter((field) => (
      field.type === 'radioGroup'
        && (field.groupId ?? field.id) === groupId
    ));
  }

  if (scopeId.startsWith(CHECKBOX_GROUP_SCOPE_PREFIX)) {
    const groupId = scopeId.slice(CHECKBOX_GROUP_SCOPE_PREFIX.length);

    return fields.filter((field) => (
      field.type === 'checkboxGroup'
        && (field.groupId ?? field.id) === groupId
    ));
  }

  if (scopeId.startsWith(FIELD_SCOPE_PREFIX)) {
    const fieldId = scopeId.slice(FIELD_SCOPE_PREFIX.length);
    const field = fields.find((currentField) => currentField.id === fieldId);

    return field ? [field] : [];
  }

  return [];
}

export function getFieldHistoryScopeByFieldId(
  fieldId: string,
  fields: PdfTemplateField[],
) {
  const field = fields.find((currentField) => currentField.id === fieldId);

  if (isNil(field)) {
    return [];
  }

  return getFieldHistoryScopeByScopeId(getFieldHistoryScopeId(field), fields);
}

export function getFieldHistoryScopeIdByFieldId(
  fieldId: string,
  fields: PdfTemplateField[],
) {
  const field = fields.find((currentField) => currentField.id === fieldId);

  return field ? getFieldHistoryScopeId(field) : null;
}
